export const appsAppGroupIdChartsSms = "/apps/:app_group_id/charts/sms";
